import React, {useRef} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Form, OverlayTrigger, Tooltip} from 'react-bootstrap'
import Dropzone from 'react-dropzone'
import Select from 'react-select'

const SelectField = ({
  options,
  field,
  form,
  styles,
  ...props
}: {
  options: any
  field: any
  form: any
  styles: any
}) => {
  const onChange = (option: any) => {
    form.setFieldValue(field.name, option)
  }

  const onBlur = () => {
    form.setFieldTouched(field.name, true)
  }

  return (
    <Select
      styles={styles}
      options={options}
      name={field.name}
      value={field.value}
      onChange={onChange}
      onBlur={onBlur}
      {...props}
    />
  )
}

const FileSchedulerForm = ({
  file,
  setFile,
  handleChangeFile,
  acceptedFileTypes,
  formik,
  fields,
  handleClickLabel,
  calculateMessage,
  inputRef,
  message,
  isLoading,
  setMessage,
  canSubmit,
  senderNumbers,
}: any) => {
  return (
    <div className='col-md-8'>
      <div className='card p-8'>
        <div className='row mb-4'>
          {file ? (
            <section className='dragAndDrop'>
              <div className='removeFile'>
                <span className='fs-10'> {file?.name}</span>
                <KTSVG
                  onClick={() => {
                    setFile('')
                  }}
                  path='/media/misc/cross-square.svg'
                  className='svg-icon  reomveIcon'
                />
              </div>
            </section>
          ) : (
            <Dropzone onDrop={handleChangeFile} accept={acceptedFileTypes}>
              {({getRootProps, getInputProps}) => (
                <section className='dragAndDrop'>
                  <KTSVG path={'/media/svg/dragandDrop.svg'} className='svg-icon-3x me-3' />
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <span className='fs-7 d-block fw-boldest'>
                      Drop files here or click to upload
                    </span>
                    <span className='text-muted fs-7'>xlsx</span>
                  </div>
                </section>
              )}
            </Dropzone>
          )}
          <span className='text-muted mt-2'>
            Scheduler template sample:
            <a href='https://api.cellcast.com/demoFiles/sample_file_scheduler.xls'>
              Download example xlsx
            </a>
          </span>
        </div>

        <form className='d-grid gap-3' onSubmit={formik.handleSubmit}>
          <div className='form-group'>
            <label htmlFor='name'>Scheduler Name</label>
            <input
              name='name'
              type='text'
              className='form-control'
              id='name'
              placeholder='Your File Schedule Name'
              value={formik.values.name}
              onChange={formik.handleChange}
            />
          </div>
          <div className='form-group'>
            <label htmlFor='description'>Description</label>
            <input
              name='description'
              type='text'
              className='form-control'
              id='description'
              placeholder='Your File Schedule Description'
              value={formik.values.description}
              onChange={formik.handleChange}
            />
          </div>
          <div className='form-group'>
            <label htmlFor='timezone'>Select time zone</label>
            <SelectField
              styles={{
                container: (base: any) => ({
                  ...base,
                  width: '100%',
                }),
              }}
              form={formik}
              field={{name: 'timezone', value: formik.values.timezone}}
              options={[
                {value: 'Australia/Adelaide', label: 'ACST|UTC +09:30/+10:30'},
                {value: 'Australia/Sydney', label: 'AEST|UTC +10:00/+11:00'},
                {value: 'Australia/Perth', label: 'AWST|UTC +08:45'},
                {value: 'Asia/Jakarta', label: 'GMT+7|UTC +07:00'},
              ]}
            />
          </div>
          <div className='form-group'>
            <label htmlFor='sender'>FROM: (Sender ID)</label>
            <SelectField
              styles={{
                container: (base: any) => ({
                  ...base,
                  width: '100%',
                }),
              }}
              form={formik}
              field={{name: 'sender', value: formik.values.sender}}
              options={senderNumbers?.list}
            />
          </div>

          {/* TODO: Integrate Template later */}
          {/* <div className='form-group'>
                <label htmlFor='template'>Template</label>
                <select
                  className='form-control'
                  id='template'
                  name='template'
                  value={template}
                  onChange={formik.handleChange}
                >
                  <option>Select Template</option>
                </select>
              </div> */}

          <div className='flex my-2 gap-2'>
            <Form.Check
              type='radio'
              id='isSharingCredit'
              label='Create message content'
              onChange={(e) => {
                if (e.target.checked) {
                  setMessage('')
                }
              }}
              className='mb-2'
              name='isSharingCredit'
            />
            <Form.Check
              type='radio'
              id='isSharingCredit'
              label='Use custom message from file template'
              onChange={(e) => {
                if (e.target.checked) {
                  setMessage('{{custom-message}}')
                }
              }}
              name='isSharingCredit'
            />
          </div>

          {message === '{{custom-message}}' || (
            <>
              <div className='flex my-2'>
                {fields.map((it: string) => (
                  <button
                    key={it}
                    type='button'
                    onClick={() => handleClickLabel(it)}
                    className='btn btn-sm btn-secondary m-1 rounded-pill'
                  >
                    <span>{it}</span>
                  </button>
                ))}
              </div>

              {message.includes('{{short-url}}') && (
                <div className='form-group'>
                  <label htmlFor='message'>Short Url Prefix</label>
                  <input
                    className='form-control'
                    name='shortUrlPrefix'
                    value={formik.values.shortUrlPrefix}
                    onChange={formik.handleChange}
                  />
                </div>
              )}

              <div className='form-group'>
                <label htmlFor='message'>Message</label>
                <textarea
                  className='form-control rounded-1'
                  id='message'
                  rows={3}
                  ref={inputRef}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
              </div>
            </>
          )}

          <div>
            <span className='text-danger'>
              {calculateMessage?.length} character remaining / {calculateMessage?.maxdata}
            </span>
            <span className='bg-primary text-white p-1 mx-1'>
              <b>({calculateMessage?.credit} SMS Used)</b>
            </span>
          </div>
          {/* TODO: Add follow up */}
          {/* <div className='form-group form-check'>
                <input
                  type='checkbox'
                  className='form-check-input'
                  id='followup'
                  checked={followUp}
                  onChange={(e) => setFollowUp(e.target.checked)}
                />
                <label className='form-check-label' htmlFor='followup'>
                  Add followup to message
                </label>
              </div> */}
          <button
            type='submit'
            className='btn btn-primary mt-2 pull-right'
            disabled={isLoading || !canSubmit}
          >
            File Scheduler Review
          </button>
        </form>
      </div>
    </div>
  )
}

export default FileSchedulerForm
